import React from "react";
import { Select } from "antd";

const { Option } = Select;

const DietPlanAddModal = ({
  isOpen,
  onClose,
  patientSearchTerm,
  setPatientSearchTerm,
  handlePatientSearch,
  isPatientSearching,
  searchedPatients,
  patientFormData,
  setPatientFormData,
  masterPlans,
  selectedMasterPlanId,
  setSelectedMasterPlanId,
  handleInputChange,
  handleSavePatient,
  loading
}) => {
  if (!isOpen) return null;
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loggedUser = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-2xl rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-5 py-2">
          <h2 className="text-lg font-semibold">Add Patient Diet Plan</h2>
          <label onClick={onClose} className="text-2xl text-gray-500 hover:text-red-500 cursor-pointer">×</label>
        </div>

        {/* Body */}
        <div className="p-5 flex flex-col gap-4">
          {/* Patient Search Section */}
          {/* <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <label className="block text-sm font-medium text-gray-700 mb-2">Search Patient (Mobile Number)</label>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Enter patient mobile number"
                value={patientSearchTerm}
                onChange={(e) => setPatientSearchTerm(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handlePatientSearch()}
                className="flex-1 border border-gray-300 text-sm rounded-lg px-3 py-2 outline-none focus:border-[#159da8]"
              />
              <button
                onClick={handlePatientSearch}
                disabled={isPatientSearching}
                className="bg-[#159da8] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#12868f] disabled:bg-gray-400 transition-colors"
              >
                {isPatientSearching ? "Searching..." : "Search"}
              </button>
            </div>

            {searchedPatients.length > 0 && (
              <div className="mt-4 border border-gray-200 rounded-lg overflow-hidden bg-white max-h-48 overflow-y-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 text-gray-600 font-bold uppercase text-[10px]">
                    <tr>
                      <th className="px-4 py-2 text-left">Patient ID</th>
                      <th className="px-4 py-2 text-left">Name</th>
                      <th className="px-4 py-2 text-left">Mobile</th>
                      <th className="px-4 py-2 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {searchedPatients.map((p) => (
                      <tr key={p.patientId} className={`hover:bg-blue-50 transition-colors ${patientFormData.patientId === p.patientId ? 'bg-blue-50' : ''}`}>
                        <td className="px-4 py-2">{p.patientId}</td>
                        <td className="px-4 py-2 font-medium">{p.firstName} {p.lastName}</td>
                        <td className="px-4 py-2 text-gray-500">{p.mobile || p.mobileNumber}</td>
                        <td className="px-4 py-2 text-center">
                          <button
                            onClick={() => {
                              setPatientFormData(prev => ({
                                ...prev,
                                patientId: p.patientId,
                                patientName: p.patientName || `${p.firstName} ${p.lastName}`,
                                mobileNumber: p.mobile || p.mobileNumber,
                                emailId: p.email || p.emailId
                              }));
                            }}
                            className={`px-3 py-1 rounded text-xs font-bold transition-all ${patientFormData.patientId === p.patientId ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-[#159da8] hover:text-white'}`}
                          >
                            {patientFormData.patientId === p.patientId ? "Selected" : "Select"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div> */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div className="col-span-2 grid grid-cols-2 gap-4 p-3 bg-emerald-50 rounded-lg border border-emerald-100">
              <div>
                <p className="text-[10px] font-bold text-emerald-600 uppercase">Selected Patient</p>
                <p className="text-sm font-bold text-emerald-900">{patientFormData.patientName || "None selected"}</p>
              </div>
              <div>
                <p className="text-[10px] font-bold text-emerald-600 uppercase">Patient ID</p>
                <p className="text-sm font-bold text-emerald-900">{patientFormData.patientId || "NA"}</p>
              </div>
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">Select Master Diet Plan</label>
              <Select
                showSearch
                placeholder="Search and select master plan"
                optionFilterProp="children"
                className="w-full h-[38px]"
                value={selectedMasterPlanId}
                onChange={(value) => setSelectedMasterPlanId(value)}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {masterPlans.map(plan => (
                  <Option key={plan.id} value={plan.id}>{plan.chartTitle} ({plan.noOfDays} Days)</Option>
                ))}
              </Select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">From Date</label>
              <input
                type="date"
                name="fromDate"
                value={patientFormData.fromDate}
                onChange={handleInputChange}
                className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 outline-none focus:border-[#159da8]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">To Date</label>
              <input
                type="date"
                name="toDate"
                value={patientFormData.toDate}
                disabled
                className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 outline-none bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div className="col-span-2 flex flex-wrap items-center gap-6 p-4 bg-emerald-50/50 rounded-lg border border-emerald-100 mt-2">
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={patientFormData.paymentRequiredYN === "Y"}
                  onChange={(e) => setPatientFormData(prev => ({ ...prev, paymentRequiredYN: e.target.checked ? "Y" : "N" }))}
                  className="w-4 h-4 rounded text-emerald-600 focus:ring-emerald-500 border-gray-300 transition-all cursor-pointer"
                />
                <span className="text-sm font-semibold text-gray-700">Payment Required from Patient</span>
              </label>

              {patientFormData.paymentRequiredYN === "Y" && (
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-gray-600">{`${loggedUser?.user?.currencyCode || ""}`}</span>
                  <input
                    type="number"
                    min="0"
                    placeholder="Enter Amount"
                    value={patientFormData.amount || ""}
                    onChange={(e) => setPatientFormData(prev => ({ ...prev, amount: e.target.value }))}
                    className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-[#159da8] bg-white w-32 font-semibold shadow-sm"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t px-5 py-4 flex justify-end gap-3">
          <label onClick={onClose} className="px-5 py-2 text-sm font-semibold text-black bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">Cancel</label>
          <button
            onClick={handleSavePatient}
            disabled={loading}
            className="bg-[#159da8] text-sm text-white px-4 py-2 rounded-lg disabled:bg-gray-400 transition-colors"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DietPlanAddModal;
